import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import SpeedIcon from "@mui/icons-material/Speed";
import { grey } from "@mui/material/colors";
import "./style.css";

const KyoriCustomSlider = ({
  kyoriSliderValue,
  setKyoriSliderValue,
  iniKyoriSliderValue,
}) => {
  const handleChange = (event, newValue) => {
    setKyoriSliderValue(newValue);
  };

  // 最大値から50000km単位でマークを生成する関数
  const createMarksFromMaxValue = (maxValue) => {
    const marks = [];
    // ステップ間隔を25000kmに変更
    for (let i = 50000; i <= maxValue; i += 50000) {
      marks.push({
        value: i,
        label: `${i}km`,
      });
    }
    return marks;
  };

  // 最大値を使ってマークを生成
  const marks = createMarksFromMaxValue(iniKyoriSliderValue[1]);

  return (
    <Box className='box' sx={{ width: 270 }}>
      <div className='iconTitle'>
        <SpeedIcon sx={{ color: grey[700] }} />
        <h3 className='sliderTitle'>走行距離フィルタ</h3>
      </div>

      <Slider
        className='slider'
        color='warning'
        value={kyoriSliderValue}
        onChange={handleChange}
        valueLabelDisplay='on'
        min={0} // ここを適宜変更してください
        max={iniKyoriSliderValue[1]}
        step={1000} // ステップ間隔
        marks={marks}
        getAriaValueText={(value) => `${value}km`}
        style={{ width: 200, margin: 30 }}
      />
    </Box>
  );
};

export default KyoriCustomSlider;
